import {
    assignCountProfileFulfilledConstants,
    assignCountProfilePendingConstants,
    assignCountProfileRejectedConstants
} from '../actions';

const initialState = {
    profiles: {},
};

export default function (state = initialState, { type = '', payload = {}, meta }) {
    switch (type) {
        case assignCountProfilePendingConstants.ASSIGN_COUNT_PROFILE_LOADED: {
            return {
                ...state,
                profiles: {
                    ...state.profiles,
                    [meta]: {
                        isLoading: true,
                        error: ''
                    },
                },
            };
        }
        case assignCountProfileFulfilledConstants.ASSIGN_COUNT_PROFILE_LOADED: {
            if (!payload.data) return state;
            const validData = {};
            for (const [key, value] of Object.entries(payload.data)) {
                validData[`${key}`] = value;
            }

            return {
                profiles: {
                    ...state.profiles,
                    [meta]: {
                        total: payload.data.total,
                        assignments: payload.data.items,
                        isLoading: false,
                        error: '',
                    },
                },
            };
        }
        case assignCountProfileRejectedConstants.ASSIGN_COUNT_PROFILE_LOADED: {
            return {
                ...state,
                profiles: {
                    ...state.profiles,
                    [meta]: {
                        isLoading: false,
                        error: payload.response ? `${payload.response.data.errorMessage || payload.response.status + ' ' + payload.response.statusText}` :
                            payload.message
                    },
                },
            };
        }
        default: {
            return state;
        }
    }
}
